export const googleClientId = "129109542624-frh5u0k3njpsodnhdic2rh1djsgusvbj.apps.googleusercontent.com";

/*
test-agent@pocketbroker.com
Ag3nt1cuS
*/
